import {
  FileText,
  Landmark,
  Building2,
  ShoppingCart,
  Users,
  UserCog,
  BookOpen,
  Stethoscope,
  CalendarCheck,
  Pill,
  GraduationCap,
  Layers,
  Receipt,
  DollarSign,
  MinusCircle,
  Package,
  Truck,
  ClipboardList,
  Ruler,
  PlusCircle,
  CheckCircle,
  Clock,
  Warehouse,
  Store,
  ListChecks,
  MessageSquare,
  Hash,
  BriefcaseBusiness,
  Award,
  CircleMinus,
  Send,
  PackageCheck,
  ShoppingBag,
  Building,
  Globe,
  CreditCard,
  BarChart3,
  TrendingUp,
  Upload,
  LineChart,
} from "../assets/registtyIcons/sidebarIcons";

// Each item: { translationKey, route, icon, section? }
// Items with `orgOnly: true` require userType === 'organization'
// `section` groups links under a translated label in the sidebar

const MERCHANT_LINKS = [
  { translationKey: "invoicesAndContainers", route: "/invoicesOfShippedContainers", icon: FileText, section: "invoicesAndContainers" },
  { translationKey: "bankApplications", route: "/bankApplications", icon: Landmark, section: "invoicesAndContainers" },
  { translationKey: "subCompanies", route: "/subCompanies", icon: Building2, section: "invoicesAndContainers" },
  { translationKey: "salesInvoices", route: "/itemInvoices", icon: ShoppingCart, section: "salesInvoices" },
  { translationKey: "suppliers", route: "/viewSuppliersPage", icon: Truck, section: "suppliers" },
  { translationKey: "customers", route: "/customers", icon: Users, section: "customers" },
  { translationKey: "employees", route: "/employees", icon: UserCog, section: "employees" },
  { translationKey: "banks", route: "/banks-page", icon: Landmark, section: "banks" },
  { translationKey: "diagrams", action: "diagrams", icon: LineChart, section: "diagrams" },
  { translationKey: "importedAndExportedBooks", route: "/issuedAndImportedBooks", icon: BookOpen, section: "importedAndExportedBooks" },
  { translationKey: "uploadDesign", action: "uploadDesign", icon: Upload, section: "addInvoiceHeader" },
];

const CLINIC_LINKS = [
  { translationKey: "reception", route: "/appointments", icon: CalendarCheck, section: "reception" },
  { translationKey: "customers", route: "/patients-page", icon: Stethoscope, section: "customers" },
  { translationKey: "treatments", route: "/treatmentsPage", icon: Pill, section: "treatments" },





  { translationKey: "employees", route: "/clinicEmployees", icon: UserCog, orgOnly: true, section: "employees" },
];

const SCHOOL_LINKS = [
  { translationKey: "students", route: "/students", icon: GraduationCap, section: "students" },


  { translationKey: "stages", route: "/education-stages", icon: Layers, section: "educationalStages" },
  {section: "educationalStages", translationKey: "addAnEduStage", action: "addStage", icon: PlusCircle},

  {section: "addKassa", translationKey: "addKassa", action: "addKassa", icon: PlusCircle},
  { translationKey: "kassat", route: "/kassat-page", icon: Receipt, section: "addKassa" },

  { translationKey: "inventory", route: "/orgShippedContainers", icon: DollarSign, section: "accounting",disabled:true ,disabledSection:true},
  { translationKey: "lists", route: "/bankApplications", icon: MinusCircle, section: "accounting",disabled:true ,disabledSection:true },

  { translationKey: "suppliers", route: "/viewSuppliersPage", icon: Receipt, section: "suppliers", disabled:true ,disabledSection:true},


  { translationKey: "theBooks", route: "/books-page", icon: BookOpen, section: "storage" },
  { translationKey: "theUniform", route: "/uniform-page", icon: Package, section: "storage" },


  { translationKey: "deliverSupplies", route: "/supplies", icon: Truck, section: "Deliveries" },
  { translationKey: "deliveredSupplies", route: "/delivered-supplies", icon: PackageCheck, section: "Deliveries" },


  { translationKey: "addOrder", route: "/add-order", icon: PlusCircle, section: "orders" },
  { translationKey: "incompleteFabricOrders", route: "/pending-product-orders", icon: Clock, section: "orders" },
  { translationKey: "completeFabricOrders", route: "/completed-product-orders", icon: CheckCircle, section: "orders" },
  { translationKey: "employees", route: "/employees", icon: UserCog, orgOnly: true, section: "employees" },
  { translationKey: "attendance", route: "/calculate-attendance", icon: CalendarCheck, orgOnly: true, section: "employees" },
  { translationKey: "workRate", route: "/attendance-employees", icon: BarChart3, orgOnly: true, section: "employees" },
  { translationKey: "stats", route: "/employees-progress", icon: TrendingUp, orgOnly: true, section: "employees" },
  { translationKey: "entitlements", route: "/entitlements-page", icon: Award, orgOnly: true, section: "employees" },
  { translationKey: "deductions", route: "/deductions-page", icon: CircleMinus, orgOnly: true, section: "employees" },
  { translationKey: "belongings", route: "/belongings", icon: BriefcaseBusiness, section: "belongings" },
];

const FABRIC_LINKS = [
  { translationKey: "rulers", route: "/rulers", icon: Ruler, section: "rulersAndColors" },
  { translationKey: "addOrder", route: "/addFabricOrder-page", icon: PlusCircle, section: "orders" },
  { translationKey: "incompleteFabricOrders", route: "/incompleteFabricOrders-page", icon: Clock, section: "orders" },
  { translationKey: "completeFabricOrders", route: "/completeFabricOrders-page", icon: CheckCircle, section: "orders" },
  { translationKey: "manualCashier", route: "/fabric-cashier", icon: Store, section: "cashier" },
  { translationKey: "manualCustomersCashier", route: "/fabric-customers-cashier", icon: Users, section: "cashier" },
  { translationKey: "invoicesList", route: "/fabric-sellInvoices", icon: ListChecks, section: "invoicesPage" },
  { translationKey: "customers", route: "/fabric-customers", icon: Users, section: "customers" },
  { translationKey: "employees", route: "/employees", icon: UserCog, orgOnly: true, section: "employees" },
  { translationKey: "uploadDesign", action: "uploadDesign", icon: Upload, section: "addInvoiceHeader" },
];

const PAPERS_LINKS = [
  { translationKey: "storage", route: "/manage-paper-rulers", icon: Warehouse, section: "storage" },

  { translationKey: "addInternalOrder", route: "/add-internal-order-page", icon: PlusCircle, section: "internalOrders" },
  { translationKey: "incompleteInternalOrders", route: "/incomplete-internal-orders", icon: Clock, section: "internalOrders" },
  { translationKey: "completedInternalOrders", route: "/completed-internal-orders", icon: CheckCircle, section: "internalOrders" },


  { translationKey: "manualSales", route: "/paper-store-cashier", icon: Store, section: "sales" },
  { translationKey: "manualCustomersSales", route: "/paper-customer-cashier", icon: Users, section: "sales" },


  { translationKey: "invoicesList", route: "/paper-sellInvoices", icon: ListChecks, section: "invoicesPage" },


  { translationKey: "customers", route: "/fabric-customers", icon: Users, section: "customers" },

  {section: "paperBanks", translationKey: "addBank", action: "addBank", icon: PlusCircle, orgOnly: true,},
  { translationKey: "paperBanks", route: "/banks-with-transactions", icon: Landmark, section: "paperBanks" },

  { translationKey: "employees", route: "/employees", icon: UserCog, orgOnly: true, section: "employees" },

  { translationKey: "addPurchaseRequest", route: "/add-paper-order", icon: ShoppingBag, section: "purchases" },
  { translationKey: "pendingPurchases", route: "/incomplete-paper-order", icon: Clock, section: "purchases" },
  { translationKey: "receivedPurchases", route: "/completed-paper-orders", icon: PackageCheck, section: "purchases" },

  { translationKey: "pendingOrders", route: "/pending-orders", icon: Clock, section: "ordersAndPreperation" },
  { translationKey: "completedOrders", route: "/prepared-orders", icon: CheckCircle, section: "ordersAndPreperation" },

  { translationKey: "uploadDesign", action: "uploadDesign", icon: Upload, section: "addInvoiceHeader" },
];

const CASHIER_LINKS = [
  { translationKey: "cashier", route: "/cashier", icon: Store, section: "cashier" },
  { translationKey: "manualCustomersCashier", route: "/manual-cashier", icon: Users, section: "cashier" },
  { translationKey: "manualCashier", route: "/manual-customers-cashier", icon: Store, section: "cashier" },
  { translationKey: "inventory", route: "/inventory", icon: Warehouse, section: "inventory" },
  { translationKey: "salesInvoices", route: "/itemInvoices", icon: ShoppingCart, section: "salesInvoices" },
  { translationKey: "invoicesList", route: "/sell-invoices", icon: ListChecks, section: "invoicesPage" },
  { translationKey: "suppliers", route: "/viewSuppliersPage", icon: Truck, section: "suppliers" },
  { translationKey: "customers", route: "/customers", icon: Users, section: "customers" },
  { translationKey: "employees", route: "/employees", icon: UserCog, section: "employees" },
  { translationKey: "diagrams", action: "diagrams", icon: LineChart, section: "diagrams",disabledSection:true },
  { translationKey: "uploadDesign", action: "uploadDesign", icon: Upload, section: "addInvoiceHeader" },
];

const BANK_LINKS = [
  { translationKey: "bankApplications", route: "/banks-invoices-applications", icon: FileText, section: "bankApplications" },
  { translationKey: "iraqiCompanies", route: "/bank-subcompanies", icon: Building2, section: "companies" },
  { translationKey: "receivers", route: "/bank-suppliers", icon: Send, section: "receivers" },
  { translationKey: "foreignBanks", route: "/foreignBanks", icon: Globe, section: "banks" },
  { translationKey: "employees", route: "/employees", icon: UserCog, orgOnly: true, section: "employees" },
];

const SQUAD_LINKS = [
  { translationKey: "kassat", route: "/kassat-page", icon: Receipt, orgOnly: true, section: "addKassa" },
  { translationKey: "attendance", route: "/calculate-attendance", icon: CalendarCheck, section: "progress" },
  { translationKey: "workRate", route: "/attendance-employees", icon: BarChart3, orgOnly: true, section: "progress" },
  { translationKey: "stats", route: "/employees-progress", icon: TrendingUp, orgOnly: true, section: "progress" },
  { translationKey: "employees", route: "/employees", icon: UserCog, orgOnly: true, section: "employees" },
];

const NO_CUSTOMER_LINKS = [
  { translationKey: "invoicesAndContainers", route: "/noCustomerInvoices", icon: FileText, section: "invoicesAndContainers" },
  { translationKey: "bankApplications", route: "/bankApplications", icon: Landmark, section: "invoicesAndContainers" },

  { translationKey: "subCompanies", route: "/subCompanies", icon: Building2, section: "employeesAndCompanies" },
  { translationKey: "employees", route: "/employees", icon: UserCog, section: "employeesAndCompanies" },


  { translationKey: "suppliers", route: "/viewSuppliersPage", icon: Truck, section: "suppliers" },

  {section: "banks", translationKey: "addBank", action: "addBank", icon: PlusCircle, userOnly: true, },
  { translationKey: "banks", route: "/banks-page", icon: Landmark, section: "banks" },

  { translationKey: "salesInvoices", route: "/itemInvoices", icon: ShoppingCart, section: "salesInvoices" },


  { translationKey: "diagrams", action: "diagrams", icon: LineChart, section: "diagrams",disabledSection:true },
  { translationKey: "importedAndExportedBooks", route: "/issuedAndImportedBooks", icon: BookOpen, section: "importedAndExportedBooks",disabled:true,disabledSection:true },
  { translationKey: "uploadDesign", action: "uploadDesign", icon: Upload, section: "addInvoiceHeader",disabledSection:true },
];

const ADMIN_LINKS = [
  {section: "banks", translationKey: "addBank", action: "addBank", icon: PlusCircle},
  { translationKey: "iraqiBanks", route: "/iraqi-banks-page", icon: Building, section: "banks" },
  { translationKey: "foreignBanks", route: "/banks-page", icon: Globe, section: "banks" },
  { translationKey: "organizations", route: "/organizations-page", icon: Building2, section: "organizations" },
  { translationKey: "subscriptions", route: "/subscription-page", icon: CreditCard, section: "organizations" },
  { translationKey: "subscriptionPlans", route: "/subscription-plans", icon: ClipboardList, section: "subscriptions" },
  { translationKey: "whatsapp", route: "/whatsapp-page", icon: MessageSquare, section: "whatsapp" },
  { translationKey: "toDoList", route: "/todoList-page", icon: ListChecks, section: "toDos" },
  { translationKey: "hsCode", route: "/hs-codes-page", icon: FileText, section: "hsCode" },


  { translationKey: "bugsAndReports", route: "/bug-reports", icon: FileText, section: "management" },
  { translationKey: "s3Management", route: "/s3-file-management", icon: Warehouse, section: "management" },


  { translationKey: "inventory", route: "/orgShippedContainers", icon: Package, section: "accounting",disabled:true },
  { translationKey: "lists", route: "/bankApplications", icon: ListChecks, section: "accounting",disabled:true  },


];

const ADMIN_SUPERADMIN_LINKS = [
  ...ADMIN_LINKS,
  { translationKey: "admins", route: "/admins", icon: UserCog, section: "admins" },
];

const INDIVIDUAL_LINKS = [
  { translationKey: "containersAndInvoices", route: "/invoiceManagement", icon: FileText },
  { translationKey: "suppliers", route: "/viewSuppliersPage", icon: Truck },
];

const AI_ORGANIZATION_LINKS = [
  { translationKey: "bank", route: "/bank-invoices", icon: Landmark },
  { translationKey: "company", route: "/ai-organization-dashboard/invoices", icon: Building2 },
];

export function getSidebarLinks(organizationType, userType) {
  // Admin/superadmin users
  if (userType === "superadmin") return ADMIN_SUPERADMIN_LINKS;
  if (userType === "admin") return ADMIN_LINKS;

  // Individual users (no organization)
  if (userType === "user") return INDIVIDUAL_LINKS;

  // Organization-based users
  switch (organizationType) {
    case "MERCHANT":
      return MERCHANT_LINKS;
    case "CLINIC":
      return CLINIC_LINKS;
    case "SCHOOL":
      return SCHOOL_LINKS;
    case "FABRICSTORE":
      return FABRIC_LINKS;
    case "PAPERFACTORY":
      return PAPERS_LINKS;
    case "SUPERMARKET":
      return CASHIER_LINKS;
    case "BANK":
      return BANK_LINKS;
    case "SQUAD":
      return SQUAD_LINKS;
    case "NO_CUSTOMER_MERCHANT":
      return NO_CUSTOMER_LINKS;
    case "AI_ORGANIZATION":
      return AI_ORGANIZATION_LINKS;
    default:
      return AI_ORGANIZATION_LINKS;
  }
}
